import React from "react";
import { Grid, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const FormFieldSection = ({
  label,
  children,
  gridSize = { xs: 12, md: 6 },
  spacing = 0,
  labelProps = {},
  containerProps = {},
  required = false,
}) => {
  const theme = useTheme();

  return (
    <Grid
      size={gridSize}
      container
      spacing={spacing}
      {...containerProps}
      sx={
        required && {
          borderLeft: `5px solid ${alpha(theme.palette.error.main, 0.7)}`,
          // backgroundColor: alpha(theme.palette.error.main, 0.1),
          // borderRadius: 4,
          pl: 2,
          ...containerProps.sx,
        }
      }
    >
      <Grid item size={12}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            ...labelProps.sx,
          }}
          {...labelProps}
        >
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Typography>
      </Grid>
      <Grid item size={{ xs: 12 }}>
        {children}
      </Grid>
    </Grid>
  );
};

export default FormFieldSection;
